// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__Tq4pq","text":"SelectPayment_text__olPNn","title":"SelectPayment_title__2Z4GO","btn":"SelectPayment_btn__3E1Tk"};